export enum KuendigungsGrund {
  GESCHAEFTSAUFGABE = 'GESCHAEFTSAUFGABE',
  INSOLVENZ = 'INSOLVENZ',
  INHABERWECHSEL = 'INHABERWECHSEL',
  KOSTEN = 'KOSTEN',
  FEHLENDE_FUNKTION = 'FEHLENDE_FUNKTION',
  MARKTBEGLEITER = 'MARKTBEGLEITER',
  ZEIT = 'ZEIT',
  FEHLENDER_SUPPORT = 'FEHLENDER_SUPPORT',
  MANGELHAFTES_ONBOARDING = 'MANGELHAFTES_ONBOARDING',
}
